import {SrtPointEvent} from '../shared/interfaces';

export const srtReasonText = (event: SrtPointEvent): string => {
  switch (event.reason) {
    case 'bad_publish_key':
      return 'Відхилено спробу подати сигнал з неправильним ключем входу.'
    case 'bad_read_key':
      return 'Відхилено спробу забрати сигнал з неправильним ключем виходу.'
    case 'not_in_tariff':
      return 'Підключення відхилено: SRT-точки недоступні на поточному тарифі.'
    case 'account_blocked':
      return 'Підключення відхилено: акаунт заблоковано.'
    case 'output_limit':
      return outputLimitText(event.used, event.limit)
    case 'unknown_point':
      return 'Точку видалено, підключення закрито.'
    default:
      return ''
  }
}

export const outputLimitText = (used: number, limit: number): string =>
  'Ліміт вихідних потоків тарифу вичерпано' + (limit ? ': ' + used + ' з ' + limit : '') +
  '. Він спільний для всіх ретрансляцій у соцмережі та виходів SRT-точок акаунта.'
